import React, { useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import PageLayout from '../../common/PageLayout'
import { useListUserScheduledPrompts } from '../../../../../api/denaliAssistant'
import Loading from '../../../../../components/molecules/Loading'
import FadeIn from '../../../../../components/molecules/Transitions/FadeIn'
import NewDigestForm from './Form'

function NewDigest () {
  const history = useHistory()
  const onComplete = useCallback((result) => {
    console.log(result, 'result')
    history.push(`/denali-ai/schedules/${result?.scheduledPrompt?.scheduleId}`)
  }, [history])
  const { data: schedules, isLoading } = useListUserScheduledPrompts()
  const availableSchedules = useMemo(() => {
    return (schedules?.scheduledPrompts || [])
      .filter(x => !x.isDigest)
      .map(x => ({
        value: x.scheduleId,
        label: x.name,
        data: x
      }))
  }, [schedules])

  return (
    <PageLayout variant='constrained'>
      {isLoading ? (
        <Loading />
      ) : (
        <FadeIn>
          <NewDigestForm onComplete={onComplete} onCancel={() => history.go(-1)} availableSchedules={availableSchedules} />
        </FadeIn>
      )}
    </PageLayout>
  )
}

export default NewDigest
